<template>
    <div>
        <el-row>
            <el-col :span="24">
                <span class="form-lable">{{ $t('common.type') }}:</span>
                <span class="info-span"> {{ cancelType }} </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <span class="form-lable">{{ $t('common.date') }}:</span>
                <span class="info-span"> {{ cancelDetail.data.date }} </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <span class="form-lable">{{ $t('common.route') }}:</span>
                <span class="info-span"> {{ getRoute(cancelDetail.data.route_type) }} </span>
            </el-col>
        </el-row>
    </div>
</template>

<script>
  import { ROUTE_PICKUP, ROUTE_DROP } from "@/config"

  export default {
    name: 'CancelDate',
    props: ['cancelDetail', 'cancelType'],
    methods: {
      getRoute (routeType) {
        switch (routeType) {
          case ROUTE_PICKUP:
            return this.$t('common.pickup_route')
          case ROUTE_DROP:
            return this.$t('common.drop_route')
          default:
            return this.$t('common.both')
        }
      }
    }
  }
</script>
